import { render, staticRenderFns } from "./Lapor.vue?vue&type=template&id=1ea8e31a"
import script from "./Lapor.vue?vue&type=script&lang=js"
export * from "./Lapor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports